import './TextInputWrapper-889df5d3.css';

var styles = {"TextInputBaseWrapper":"prc-components-TextInputBaseWrapper-ueK9q","TextInputWrapper":"prc-components-TextInputWrapper-i1ofR"};

export { styles as default };
